import { IconProps } from "../../../types/style";

const UploadDocIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3333 4.63562H12.8933C12.765 4.63562 12.635 4.60616 12.5208 4.54971L9.89333 3.26019C9.5475 3.09 9.16083 3 8.77333 3H6.66667C4.36917 2.99918 2.5 4.83445 2.5 7.09028V16.9089C2.5 19.1647 4.36917 21 6.66667 21H9.16667C9.62667 21 10 20.6343 10 20.1818C10 19.7293 9.62667 19.3636 9.16667 19.3636H6.66667C5.28833 19.3636 4.16667 18.2622 4.16667 16.9089V9.54493H20.8333V16.9089C20.8333 18.2622 19.7117 19.3636 18.3333 19.3636H15.8333C15.3733 19.3636 15 19.7293 15 20.1818C15 20.6343 15.3733 21 15.8333 21H18.3333C20.6308 21 22.5 19.1647 22.5 16.9089V8.72672C22.5 6.47089 20.6308 4.63562 18.3333 4.63562ZM4.16667 7.09028C4.16667 5.73694 5.28833 4.63562 6.66667 4.63562H8.77333C8.90167 4.63562 9.03 4.66508 9.14583 4.72235L11.7758 6.01268C12.1217 6.18205 12.5075 6.27124 12.8933 6.27124H18.3333C19.4183 6.27124 20.335 6.95773 20.68 7.90768H4.16667V7.09028ZM14.4108 15.1874L13.3333 14.1294V20.1818C13.3333 20.6343 12.96 21 12.5 21C12.04 21 11.6667 20.6343 11.6667 20.1818V14.1294L10.5892 15.1874C10.4267 15.3469 10.2133 15.4271 10 15.4271C9.78667 15.4271 9.57333 15.3469 9.41083 15.1874C9.085 14.8674 9.085 14.3503 9.41083 14.0304L10.755 12.7106C11.6867 11.795 13.3125 11.795 14.245 12.7106L15.5892 14.0304C15.915 14.3503 15.915 14.8674 15.5892 15.1874C15.2633 15.5073 14.7367 15.5073 14.4108 15.1874Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default UploadDocIcon;
